import React, { useRef, useEffect, useState } from 'react';

const Parchment = ({ initialData = { simchas: [] }, title = 'שמחות בקהילה', showTitle = true, bgColor }) => {
  const contentRef = useRef(null);
  const containerRef = useRef(null);
  const [needsScroll, setNeedsScroll] = useState(false);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const simchas = (initialData.simchas || []).filter(
    s => !s.expiryDate || new Date(s.expiryDate) > now
  );

  useEffect(() => {
    const checkScroll = () => {
      if (containerRef.current) {
        const containerHeight = containerRef.current.clientHeight;
        const itemEl = containerRef.current.querySelector('[data-simcha-item]');
        const itemHeight = itemEl?.offsetHeight || 0;
        const contentHeight = simchas.length * (itemHeight + 10);
        setNeedsScroll(contentHeight > containerHeight + containerHeight * 0.1);
      }
    };
    const timer = setTimeout(checkScroll, 100);
    const ro = new ResizeObserver(checkScroll);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => { clearTimeout(timer); ro.disconnect(); };
  }, [simchas]);

  const getLabel = (type, customType) => {
    const map = {
      birth_boy: 'הולדת הבן', birth_girl: 'הולדת הבת',
      grandchild_boy: 'הולדת נכד', grandchild_girl: 'הולדת נכדה',
      engagement_boy: 'אירוסי הבן', engagement_girl: 'אירוסי הבת',
      wedding_boy: 'חתונת הבן', wedding_girl: 'חתונת הבת',
      bar_mitzvah: 'בר מצווה', other: customType || 'שמחה',
    };
    return map[type] || customType || 'שמחה';
  };

  const boldLabel = (type, label, boldWords) => {
    if (type !== 'other') return <strong>{label}</strong>;
    if (!boldWords?.length) return label;
    return label.split(/(\s+)/).map((w, i) =>
      boldWords.includes(w.trim()) && w.trim() ? <strong key={i}>{w}</strong> : w
    );
  };

  const renderCard = (simcha, keyPrefix = '', isOriginal = true) => {
    const label = getLabel(simcha.type, simcha.customType);
    return (
      <div
        key={`${keyPrefix}${simcha.id}`}
        {...(isOriginal && { 'data-simcha-item': true })}
        style={{
          backgroundColor: '#fdf0c0',
          border: '1px solid #c8a84b',
          borderRadius: '5px',
          padding: '9px 14px',
          boxShadow: '0 1px 4px rgba(80,50,0,0.1), inset 0 0 0 2px rgba(200,168,75,0.1)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', marginBottom: '3px' }}>
          <span style={{ color: '#b8860b', fontSize: '0.65em', flexShrink: 0 }}>✦</span>
          <span style={{ color: '#3b2000', fontWeight: 700, fontSize: '0.875em' }}>
            {simcha.name}
          </span>
        </div>
        <div style={{ color: '#6b4a0a', fontSize: '0.72em', paddingRight: '1.1em' }}>
          ל{boldLabel(simcha.type, label, simcha.customTypeBold)}{simcha.celebrant ? ` ${simcha.celebrant}` : ''}
        </div>
        {simcha.additionalText && (
          <div style={{ color: '#8b6914', fontSize: '0.67em', fontStyle: 'italic', marginTop: '2px', paddingRight: '1.1em' }}>
            {simcha.additionalText}
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{
      padding: '12px',
      direction: 'rtl',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      backgroundColor: bgColor || '#fdf6e3',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{ textAlign: 'center', marginBottom: '10px', paddingBottom: '8px' }}>
          <div style={{ color: '#c8a84b', fontSize: '0.6em', letterSpacing: '0.35em', marginBottom: '3px' }}>
            ✦&nbsp;&nbsp;✦&nbsp;&nbsp;✦
          </div>
          <h3 style={{ margin: '0 0 5px 0', color: '#3b2000', fontWeight: 700, fontSize: '0.875em', letterSpacing: '0.05em' }}>
            {title}
          </h3>
          <div style={{ height: '1px', background: 'linear-gradient(to left, transparent, #c8a84b 30%, #c8a84b 70%, transparent)' }} />
        </div>
      )}

      <div ref={containerRef} style={{ overflow: 'hidden', flex: 1, position: 'relative' }}>
        {simchas.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#8b6914', fontSize: '0.8em', padding: '10px' }}>
            אין שמחות כרגע
          </div>
        ) : (
          <>
            {needsScroll && (
              <style>
                {`@keyframes scrollSimchasParchment {
                  0%   { transform: translateY(0); }
                  100% { transform: translateY(calc(-100% / 3)); }
                }`}
              </style>
            )}
            <div ref={contentRef} style={{ animation: needsScroll ? 'scrollSimchasParchment 30s linear infinite' : 'none' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {simchas.map(s => renderCard(s, '', true))}
                {needsScroll && simchas.map(s => renderCard(s, 'dup1-', false))}
                {needsScroll && simchas.map(s => renderCard(s, 'dup2-', false))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Parchment;
